import React, { FunctionComponent } from 'react';

import Head from 'next/head';

import { pickPreloadCandidates, WebImageSizes } from '@utils/picture';

type ImagePreloadProps = {
    sources: Global.ImageSet | null | undefined;
    mediaQueries?: Record<WebImageSizes, number>;
    sizes?: WebImageSizes[];
};

const getPreloadAttrs = (imageSrcSet: string): Record<string, string> => ({
    imagesrcset: imageSrcSet,
    fetchpriority: 'high',
});

export const ImagePreload: FunctionComponent<ImagePreloadProps> = (props) => {
    const { sources, mediaQueries, sizes } = props;

    if (sources === null || sources === undefined) return null;

    return (
        <Head>
            {pickPreloadCandidates(sources, mediaQueries, sizes).map((candidate) => (
                <link
                    key={`${candidate.media}-${candidate.href}`}
                    rel="preload"
                    as="image"
                    href={candidate.href}
                    media={candidate.media}
                    type={candidate.type}
                    {...getPreloadAttrs(candidate.imageSrcSet)}
                />
            ))}
        </Head>
    );
};
